<div class="modal-content modal-content-right">
  <div class="modal-header">
    <h5 class="modal-title"> {{modalTitle}}</h5>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <div class="row">
        <div class="col-md-12">
          <label>
            {{modalSubTitle}}
          </label>
          <ag-grid-angular
            style="width: 100%" 
            class="ag-theme-material"
            [rowData]="itemsDataSource" 
            (gridReady)="onGridReady($event)"
            [pagination]="true"
            [paginationPageSize]="10"
            [columnDefs]="columns">
          </ag-grid-angular>
        </div>
      </div>
  </div>
</div>
